/* eslint-disable prefer-template */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable prefer-const */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable no-plusplus */
/* eslint-disable no-unused-vars */
/* eslint-disable object-shorthand */
/* eslint-disable react/self-closing-comp */
/* eslint-disable arrow-body-style */

import { useEffect, useState, useMemo } from 'react';
import './transaction.css';
import * as React from 'react';
import Button from '@mui/material/Button';
import IosShareRoundedIcon from '@mui/icons-material/IosShareRounded';
import RefreshIcon from '@mui/icons-material/Refresh';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import IconButton from '@mui/material/IconButton';
import InfoOutlinedIcon from '@mui/icons-material/InfoOutlined';
import CircularProgress from '@mui/material/CircularProgress';
import moment from 'moment-timezone';
import Skeleton from '@mui/material/Skeleton';
import DatePicker from 'react-datepicker';
import { Form, Modal } from 'react-bootstrap';
import { format, startOfMonth, subMonths } from 'date-fns';
import { formatSecondsToMinutesAndSeconds } from '../../utils/formatDuration';
import TgSubcription from '../TgSubcription/TgSubcription';
import { tgLogsService } from '../../services/tgLogsService';
import { useTgTransactionStore } from '../../store/tgTransactionStore';

function isFeeOrRechargeLogType(logType) {
  if (!logType) return false;
  return logType.includes('FEE') || logType.includes('_RECHARGE');
}

function transactionDescription(data) {
  if (data.logType === 'PHONE_NUMBER_FEES') {
    const description = data.description || 'Phone Number Monthly Fee';
    if (data.phoneNumber && !String(description).includes(data.phoneNumber)) {
      return `${description} · ${data.phoneNumber}`;
    }
    return description;
  }
  if (isFeeOrRechargeLogType(data.logType)) {
    return data.description;
  }
  return `${data.description} - ref: ${data.logType === 'SMS' ? data.smsId : data.callId}`;
}

const TgTransaction = () => {
  const [posts, SetPosts] = useState([]);
  const [postPerPage, SetPostPerPage] = useState(10);
  const [currentPage, SetCurrentPage] = useState(0);
  const [exportDateRange, setExportDateRange] = useState([startOfMonth(new Date()), new Date()]);
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [showExportModal, setShowExportModal] = useState(false);
  const [exportMethod, setExportMethod] = useState('email');
  const [isExporting, setIsExporting] = useState(false);
  const [pageIndex, setPageIndex] = useState([{ start: 0, end: 10 }]);
  const {
    logs,
    summary,
    loading,
    timeZone,
    setTimeZone,
    loadTransactions,
    loadMoreTransactions,
    exportLogs,
    logType,
    status,
    statusCounts,
    setLogTypeAndStatus,
    loadStatusCounts,
    dateRange,
    setDateRange,
    totalLogs,
  } = useTgTransactionStore();

  const [pickerFrom, setPickerFrom] = useState(() => {
    if (dateRange?.from) return new Date(`${dateRange.from}T00:00:00`);
    const d = new Date();
    return new Date(d.getFullYear(), d.getMonth(), 1);
  });
  const [pickerTo, setPickerTo] = useState(() => {
    if (dateRange?.to) return new Date(`${dateRange.to}T00:00:00`);
    return new Date();
  });

  const fmtDate = (d) => {
    if (!d) return '';
    const pad = (n) => String(n).padStart(2, '0');
    return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())}`;
  };

  useEffect(() => {
    const handleBeforeUnload = (e) => {
      if (isExporting) {
        e.preventDefault();
        e.returnValue = '';
      }
    };

    window.addEventListener('beforeunload', handleBeforeUnload);
    return () => window.removeEventListener('beforeunload', handleBeforeUnload);
  }, [isExporting]);

  useEffect(() => {
    if (exportDateRange[0]) {
      setStartDate(exportDateRange[0]);
    } else {
      setStartDate(undefined);
    }

    if (exportDateRange[1]) {
      setEndDate(exportDateRange[1]);
    } else {
      setEndDate(undefined);
    }
  }, [exportDateRange]);

  const applyDateRange = async (from, to) => {
    setDateRange(from, to);
    try {
      await Promise.all([
        useTgTransactionStore.getState().loadStatusCounts(),
        (async () => {
          const freshLogs = await useTgTransactionStore.getState().loadTransactions({
            limit: postPerPage,
            force: true,
            resetCursor: true,
          });
          SetPosts(freshLogs);
          setPageIndex([{ start: 0, end: postPerPage }]);
          SetCurrentPage(0);
        })(),
      ]);
    } catch (error) {
      console.error('Error applying date range:', error);
    }
  };

  useEffect(() => {
    loadStatusCounts();
  }, []);

  const applyFilter = async (nextLogType, nextStatus) => {
    setLogTypeAndStatus(nextLogType, nextStatus);
    try {
      await useTgTransactionStore.getState().loadStatusCounts();
      const freshLogs = await useTgTransactionStore.getState().loadTransactions({
        limit: postPerPage,
        force: true,
        resetCursor: true,
      });
      SetPosts(freshLogs);
      setPageIndex([{ start: 0, end: postPerPage }]);
      SetCurrentPage(0);
    } catch (error) {
      console.error('Error applying filter:', error);
    }
  };

  const subStatusOptions = useMemo(() => {
    if (logType === 'CALL') {
      return [
        { key: 'all', label: 'All', count: statusCounts.callStatuses.all },
        { key: 'completed', label: 'Completed', count: statusCounts.callStatuses.completed },
        { key: 'failed', label: 'Failed', count: statusCounts.callStatuses.failed },
        { key: 'busy', label: 'Busy', count: statusCounts.callStatuses.busy },
        { key: 'no-answer', label: 'No Answer', count: statusCounts.callStatuses['no-answer'] },
        { key: 'canceled', label: 'Canceled', count: statusCounts.callStatuses.canceled },
        { key: 'pending', label: 'Pending', count: statusCounts.callStatuses.pending },
      ].filter((opt) => opt.count > 0);
    }
    if (logType === 'SMS') {
      return [
        { key: 'all', label: 'All', count: statusCounts.smsStatuses.all },
        { key: 'delivered', label: 'Delivered', count: statusCounts.smsStatuses.delivered },
        { key: 'failed', label: 'Failed', count: statusCounts.smsStatuses.failed },
        { key: 'undelivered', label: 'Undelivered', count: statusCounts.smsStatuses.undelivered },
      ].filter((opt) => opt.count > 0);
    }
    return [];
  }, [logType, statusCounts]);

  const prevPageClick = () => {
    if (currentPage > 0) {
      const newCurrentPage = currentPage - 1;
      SetCurrentPage(newCurrentPage);
      const newStart = pageIndex[newCurrentPage].start;
      const newEnd = pageIndex[newCurrentPage].end;
      SetPosts(logs.slice(newStart, newEnd));
    }
  };

  const nextPageClick = () => {
    const nextPageIndex = currentPage + 1;
    const pageIndexExist = pageIndex[nextPageIndex];
    if (pageIndexExist) {
      SetCurrentPage(nextPageIndex);
      const newStart = pageIndex[nextPageIndex].start;
      const newEnd = pageIndex[nextPageIndex].end;
      SetPosts(logs.slice(newStart, newEnd));
    } else {
      fetchFilteredData();
    }
  };

  const OnPerPostChangeEvent = (e) => {
    const pageSize = e.target.value;
    if (logs.length >= pageSize) {
      SetPosts(logs.slice(0, pageSize));
    } else if (logs.length < pageSize) {
      // find the difference between the new page size and the current data length
      const difference = pageSize - logs.length;
      fetchAdditionalData(difference);
    } else {
      fetchData(pageSize);
    }

    // create the page index array based on the new page size
    const newPageIndex = Array.from({ length: Math.ceil(logs.length / pageSize) }, (_, i) => {
      return { start: i * pageSize, end: (i + 1) * pageSize };
    });
    setPageIndex(newPageIndex);
    SetPostPerPage(pageSize);
    SetCurrentPage(0);
  };

  useEffect(() => {
    const getTimeZone = () => {
      const { timeZone } = Intl.DateTimeFormat().resolvedOptions();
      setTimeZone(timeZone);
      fetchData();
    };

    getTimeZone();
  }, [setTimeZone]);

  const fetchData = async (perPageLimit) => {
    const limit = perPageLimit || postPerPage;

    try {
      const freshLogs = await loadTransactions({ limit, force: true, resetCursor: true });
      SetPosts(freshLogs);
      setPageIndex([
        {
          start: 0,
          end: postPerPage,
        },
      ]);
      SetCurrentPage(0);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const refreshData = async () => {
    try {
      await loadStatusCounts();
      const freshLogs = await loadTransactions({ limit: postPerPage, force: true, resetCursor: true });
      SetPosts(freshLogs);
      setPageIndex([
        {
          start: 0,
          end: postPerPage,
        },
      ]);
      SetCurrentPage(0);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchFilteredData = async () => {
    try {
      const nextLogs = await loadMoreTransactions({ limit: postPerPage });
      SetPosts(nextLogs);
      setPageIndex([
        ...pageIndex,
        { start: pageIndex[currentPage].end, end: pageIndex[currentPage].end + postPerPage },
      ]);
      SetCurrentPage(currentPage + 1);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  const fetchAdditionalData = async (limit) => {
    try {
      const additionalLogs = await loadMoreTransactions({ limit });
      SetPosts([...posts, ...additionalLogs]);
    } catch (error) {
      console.error('Error fetching data:', error);
    }
  };

  // const exportToExcel = () => {
  //   if (data.length === 0) return;

  //   const filteredData = data.map(
  //     ({
  //       id,
  //       updatedAt,
  //       walletBalance,
  //       price,
  //       to,
  //       from,
  //       messageCarrierFees,
  //       description,
  //       messageSegments,
  //       callDuration,
  //       callStatus,
  //       smsStatus,
  //     }) => ({
  //       id,
  //       updatedAt,
  //       to,
  //       from,
  //       price,
  //       walletBalance,
  //       callStatus,
  //       callDuration,
  //       smsStatus,
  //       messageSegments,
  //       messageCarrierFees,
  //       description,
  //     })
  //   ); // Example: Exporting only 'id' and 'name'

  //   const csvContent =
  //     'data:text/csv;charset=utf-8,' +
  //     'ID,Timestamp,To,From,Description,price,SMS Status,SMS Segments,Carrier Fees,Call Status,Call Duration,Wallet Balance\n' + // Column names
  //     filteredData
  //       .map((row) => [
  //         row.id,
  //         moment.tz(row.updatedAt.toDate(), timeZone).format('MMMM Do YYYY, h:mm:ss a'),
  //         row.to,
  //         row.from,
  //         row.description,
  //         row.price,
  //         row.smsStatus,
  //         row.messageSegments,
  //         row.messageCarrierFees,
  //         row.callStatus,
  //         row.callDuration,
  //         row.walletBalance,
  //       ])
  //       .join('\n');
  //   const encodedUri = encodeURI(csvContent);
  //   const link = document.createElement('a');
  //   link.setAttribute('href', encodedUri);
  //   link.setAttribute('download', 'data.csv');
  //   document.body.appendChild(link);
  //   link.click();
  // };
  const downloadLogsLocally = async ({ from, to, timezone }) => {
    const response = await tgLogsService.downloadLogs({ from, to, timezone });
    const blob = new Blob([response.data], { type: 'text/csv' });
    const url = window.URL.createObjectURL(blob);
    const link = document.createElement('a');
    link.href = url;
    link.download = `transaction-logs-${from}-${to}.csv`;
    document.body.appendChild(link);
    link.click();
    link.remove();
    window.URL.revokeObjectURL(url);
  };

  const handleLogExport = async (e) => {
    e.preventDefault();
    if (!exportDateRange[0] || !exportDateRange[1]) {
      alert('Please select a date range');
      return;
    }
    const from = format(exportDateRange[0], 'yyyy-MM-dd');
    const to = format(exportDateRange[1], 'yyyy-MM-dd');

    setIsExporting(true);
    try {
      if (exportMethod === 'download') {
        await downloadLogsLocally({ from, to, timezone: timeZone });
      } else {
        await exportLogs({ from, to, timezone: timeZone });
        alert('Your request has been submitted. You will receive an email shortly with the transaction logs.');
      }
      setShowExportModal(false);
    } catch (error) {
      console.error('Export failed:', error);
      alert('Export failed. Please try again.');
    } finally {
      setIsExporting(false);
    }
  };

  const loader = [1, 2, 3, 4, 5];
  const todayDate = new Date();
  const minAllowedDate = startOfMonth(subMonths(todayDate, 5));
  const canGoPrev = currentPage > 0;
  const canGoNext = pageIndex[currentPage + 1] != null || logs.length < totalLogs;

  return (
    <>
      <div className="transaction-card">
        {summary && <TgSubcription summary={summary} setTimeZone={setTimeZone} />}
        <div className="">
          <>
            <div className="container-fluid mt-5 mb-5">
              <div className="row justify-content-center">
                <div className="col-md-12">
                  <div className="card">
                    <div className="card-body p-0">
                      <div className="d-flex justify-content-end py-3">
                        <div className="button-export me-5">
                          <Stack direction="row" spacing={2}>
                            <Button variant="outlined" startIcon={<RefreshIcon />} onClick={refreshData}>
                              Refresh
                            </Button>
                            <Button
                              variant="outlined"
                              startIcon={<IosShareRoundedIcon />}
                              onClick={() => setShowExportModal(!showExportModal)}
                            >
                              Export
                            </Button>
                          </Stack>
                        </div>
                      </div>
                      <div className="d-flex flex-column ms-5 mb-3">
                        <div className="mb-3 d-flex align-items-center gap-2">
                          <span style={{ fontSize: 14, fontWeight: 600 }}>Date Range:</span>
                          <DatePicker
                            selectsRange
                            startDate={pickerFrom}
                            endDate={pickerTo}
                            onChange={([from, to]) => {
                              setPickerFrom(from);
                              setPickerTo(to);
                              if (from && to) {
                                applyDateRange(fmtDate(from), fmtDate(to));
                              }
                            }}
                            minDate={minAllowedDate}
                            maxDate={todayDate}
                            dateFormat="MMM dd, yyyy"
                            calendarStartDay={1}
                            customInput={
                              <Form.Control
                                style={{ fontSize: 13, width: 240, cursor: 'pointer' }}
                                readOnly
                                value={
                                  pickerFrom && pickerTo
                                    ? `${format(pickerFrom, 'MMM dd, yyyy')} – ${format(pickerTo, 'MMM dd, yyyy')}`
                                    : pickerFrom
                                      ? format(pickerFrom, 'MMM dd, yyyy')
                                      : ''
                                }
                              />
                            }
                          />
                        </div>
                        <Stack direction="row" spacing={1} className="mb-2">
                          {[
                            { key: 'all', label: 'All', count: statusCounts.types.all },
                            { key: 'SMS', label: 'SMS', count: statusCounts.types.sms },
                            { key: 'CALL', label: 'Call', count: statusCounts.types.call },
                          ].map((opt) => (
                            <Button
                              key={opt.key}
                              size="small"
                              variant={logType === opt.key ? 'contained' : 'outlined'}
                              onClick={() => applyFilter(opt.key, 'all')}
                            >
                              {opt.label} ({opt.count ?? 0})
                            </Button>
                          ))}
                        </Stack>
                        {subStatusOptions.length > 0 && (
                          <Stack direction="row" spacing={1} flexWrap="wrap">
                            {subStatusOptions.map((opt) => (
                              <Button
                                key={opt.key}
                                size="small"
                                variant={status === opt.key ? 'contained' : 'outlined'}
                                color="secondary"
                                onClick={() => applyFilter(logType, opt.key)}
                              >
                                {opt.label} ({opt.count ?? 0})
                              </Button>
                            ))}
                          </Stack>
                        )}
                      </div>
                      <div className="table-responsive">
                        <table className="table table-text-small mb-0">
                          <thead className="thead-primary table-sorting">
                            <tr>
                              <th
                                className="text-muted "
                                style={{ fontSize: '16px', fontWeight: '700', textAlign: 'center' }}
                              >
                                Id
                              </th>
                              <th
                                className="text-muted "
                                style={{ fontSize: '16px', fontWeight: '700', textAlign: 'center' }}
                              >
                                Event time
                              </th>
                              <th
                                className="text-muted "
                                style={{ fontSize: '16px', fontWeight: '700', textAlign: 'center' }}
                              >
                                From Number
                              </th>
                              <th
                                className="text-muted "
                                style={{ fontSize: '16px', fontWeight: '700', textAlign: 'center' }}
                              >
                                To Number
                              </th>
                              <th
                                className="text-muted "
                                style={{ fontSize: '16px', fontWeight: '700', textAlign: 'center' }}
                              >
                                Description
                              </th>
                              <th
                                className="text-muted "
                                style={{ fontSize: '16px', fontWeight: '700', textAlign: 'center' }}
                              >
                                Segments/Duration
                              </th>
                              <th
                                className="text-muted "
                                style={{ fontSize: '16px', fontWeight: '700', textAlign: 'center' }}
                              >
                                Amount
                              </th>
                              <th
                                className="text-muted "
                                style={{ fontSize: '16px', fontWeight: '700', textAlign: 'center' }}
                              >
                                Wallet Balance
                              </th>
                              <th
                                className="text-muted "
                                style={{ fontSize: '16px', fontWeight: '700', textAlign: 'center' }}
                              >
                                Status
                              </th>
                            </tr>
                          </thead>
                          <tbody>
                            {loading
                              ? loader?.map((e) => {
                                return (
                                  <>
                                    <tr style={{ width: '100%', height: '1vh' }}>
                                      <td
                                        style={{
                                          fontSize: '14px',
                                          padding: '10px 10px 10px 10px',
                                          fontWeight: '400',
                                          textAlign: 'center',
                                        }}
                                      >
                                        {' '}
                                        <Skeleton variant="text" width={'100%'} height={20} />
                                      </td>
                                      <td
                                        style={{
                                          fontSize: '14px',
                                          padding: '10px 10px 10px 10px',
                                          fontWeight: '400',
                                          textAlign: 'center',
                                        }}
                                      >
                                        <Skeleton variant="text" width={'100%'} height={20} />
                                      </td>
                                      <td
                                        style={{
                                          fontSize: '14px',
                                          padding: '10px 10px 10px 10px',
                                          fontWeight: '400',
                                          textAlign: 'center',
                                        }}
                                      >
                                        <Skeleton variant="text" width={'100%'} height={20} />
                                      </td>
                                      <td
                                        style={{
                                          fontSize: '14px',
                                          padding: '10px 10px 10px 10px',
                                          fontWeight: '400',
                                          textAlign: 'center',
                                        }}
                                      >
                                        <Skeleton variant="text" width={'100%'} height={20} />
                                      </td>
                                      <td
                                        style={{
                                          fontSize: '14px',
                                          padding: '10px 10px 10px 10px',
                                          fontWeight: '400',
                                          textAlign: 'center',
                                        }}
                                      >
                                        <Skeleton variant="text" width={'100%'} height={20} />
                                      </td>
                                      <td
                                        style={{
                                          fontSize: '14px',
                                          padding: '10px 10px 10px 10px',
                                          fontWeight: '400',
                                          textAlign: 'center',
                                        }}
                                      >
                                        <Skeleton variant="text" width={'100%'} height={20} />
                                      </td>
                                      <td
                                        style={{
                                          fontSize: '14px',
                                          padding: '10px 10px 10px 10px',
                                          fontWeight: '400',
                                          textAlign: 'center',
                                        }}
                                      >
                                        <Skeleton variant="text" width={'100%'} height={20} />
                                      </td>
                                      <td
                                        style={{
                                          fontSize: '14px',
                                          padding: '10px 10px 10px 10px',
                                          fontWeight: '400',
                                          textAlign: 'center',
                                        }}
                                      >
                                        <Skeleton variant="text" width={'100%'} height={20} />
                                      </td>
                                      <td
                                        style={{
                                          fontSize: '14px',
                                          padding: '10px 10px 10px 10px',
                                          fontWeight: '400',
                                          textAlign: 'center',
                                        }}
                                      >
                                        <Skeleton variant="text" width={'100%'} height={20} />
                                      </td>
                                    </tr>
                                  </>
                                );
                              })
                              : posts?.map((data, index) => {
                                return (
                                  <tr key={data.id} style={{ width: '100%', height: '1vh' }} className="">
                                    <td
                                      className="text-success "
                                      style={{
                                        fontSize: '14px',
                                        padding: '10px 10px 10px 10px',
                                        fontWeight: '400',
                                        textAlign: 'center',
                                      }}
                                    >
                                      {data.id}
                                    </td>
                                    <td
                                      className="text-dark"
                                      style={{
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        padding: '10px 10px 10px 10px',
                                        textAlign: 'center',
                                      }}
                                    >
                                      {data.billingAt || data.timestamp
                                        ? moment.tz(data.billingAt || data.timestamp, timeZone).format('MMMM Do YYYY, h:mm:ss a')
                                        : '—'}
                                    </td>
                                    <td
                                      className="text-dark"
                                      style={{
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        padding: '10px 10px 10px 10px',
                                        textAlign: 'center',
                                      }}
                                    >
                                      {data.from}
                                    </td>
                                    <td
                                      className="text-dark"
                                      style={{
                                        fontSize: '14px',
                                        fontWeight: '500',
                                        padding: '10px 10px 10px 10px',
                                        textAlign: 'center',
                                      }}
                                    >
                                      {data.to}
                                    </td>
                                    <td
                                      className="text-dark"
                                      style={{
                                        fontSize: '14px',
                                        textAlign: 'center',
                                        padding: '10px 10px 10px 10px',
                                        fontWeight: '500',
                                      }}
                                    >
                                      {transactionDescription(data)}
                                    </td>
                                    <td
                                      className="text-dark"
                                      style={{
                                        fontSize: '14px',
                                        textAlign: 'center',
                                        padding: '10px 10px 10px 10px',
                                        fontWeight: '500',
                                      }}
                                    >
                                      {data.logType === 'SMS' || data.logType === 'CALL'
                                        ? data.logType === 'SMS'
                                          ? `${data.messageSegments}`
                                          : formatSecondsToMinutesAndSeconds(data.callDuration)
                                        : '-'}
                                    </td>
                                    <td
                                      style={{
                                        fontSize: '14px',
                                        padding: '10px 10px 10px 10px',
                                        fontWeight: 'bolder',
                                        textAlign: 'center',
                                      }}
                                    >
                                      {data.logType.includes(`_RECHARGE`) ? (
                                        <span className="text-success">+${Number(data.price).toFixed(4)}</span>
                                      ) : (
                                        <span className="text-danger">-${Number(data.price).toFixed(4)}</span>
                                      )}
                                    </td>
                                    <td
                                      className=" text-success"
                                      style={{
                                        fontSize: '14px',
                                        padding: '10px 10px 10px 10px',
                                        fontWeight: 'bolder',
                                        textAlign: 'center',
                                      }}
                                    >
                                      {data.walletBalance > 0 ? (
                                        <span className="text-success">${Number(data.walletBalance).toFixed(4)}</span>
                                      ) : (
                                        <span className="text-danger">${Number(data.walletBalance).toFixed(4)}</span>
                                      )}
                                    </td>
                                    <td
                                      className="text-dark"
                                      style={{
                                        fontSize: '14px',
                                        textAlign: 'center',
                                        fontWeight: '500',
                                        padding: '10px 10px 10px 10px',
                                      }}
                                    >
                                      {data.logType === 'SMS' || data.logType === 'CALL' ? (
                                        <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', gap: '4px' }}>
                                          <span>
                                            {data.logType === 'SMS' ? data.smsStatus : data.callStatus}
                                          </span>
                                          {data.statusReason && (
                                            <Tooltip title={data.statusReason} arrow>
                                              <IconButton size="small" style={{ padding: 0, color: '#1976d2' }}>
                                                <InfoOutlinedIcon fontSize="small" />
                                              </IconButton>
                                            </Tooltip>
                                          )}
                                        </div>
                                      ) : (
                                        '-'
                                      )}
                                    </td>
                                  </tr>
                                );
                              })}
                          </tbody>
                        </table>
                      </div>
                      <div className="table-filter-info d-flex justify-content-between align-items-center">
                        <div>
                          <select
                            className="form-select form-select-sm"
                            aria-label="Rows per page"
                            defaultValue={postPerPage}
                            onChange={OnPerPostChangeEvent}
                          >
                            <option value="10">10</option>
                            <option value="20">20</option>
                            <option value="50">50</option>
                            <option value="100">100</option>
                            <option value="500">500</option>
                          </select>
                        </div>
                        <div className="dt-pagination">
                          <ul className="dt-pagination-ul">
                            <li className={`dt-item ${!canGoPrev ? 'disabled' : ''}`}>
                              <a
                                className="dt-link"
                                onClick={canGoPrev ? prevPageClick : undefined}
                                aria-disabled={!canGoPrev}
                              >
                                Prev
                              </a>
                            </li>
                            <li className={`dt-item ${!canGoNext ? 'disabled' : ''}`}>
                              <a
                                className="dt-link"
                                onClick={canGoNext ? nextPageClick : undefined}
                                aria-disabled={!canGoNext}
                              >
                                Next
                              </a>
                            </li>
                          </ul>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <Modal show={showExportModal} centered keyboard onHide={() => !isExporting && setShowExportModal(false)}>
              <Modal.Header closeButton>
                <Modal.Title>Download transaction logs</Modal.Title>
              </Modal.Header>
              <Modal.Body>
                <div>
                  <Form onSubmit={handleLogExport}>
                    <Form.Group className="mb-3" controlId="formBasicEmail">
                      <Form.Label className="fw-bold">Date Range</Form.Label>
                      <div className="d-flex">
                        <DatePicker
                          className="w-100"
                          maxDate={todayDate}
                          minDate={minAllowedDate}
                          selectsRange
                          startDate={startDate}
                          endDate={endDate}
                          onChange={(update) => {
                            setExportDateRange(update);
                          }}
                          dateFormat="dd MMM, yyyy"
                          calendarStartDay={1}
                          value={
                            exportDateRange[0] && exportDateRange[1]
                              ? `${format(exportDateRange[0], 'MMM dd, yyyy')} to ${format(exportDateRange[1], 'MMM dd, yyyy')}`
                              : exportDateRange[0]
                                ? format(exportDateRange[0], 'MMM dd, yyyy')
                                : ''
                          }
                          customInput={
                            <Form.Control
                              className="p-2"
                              type="input"
                              style={{
                                fontSize: '14px',
                              }}
                            />
                          }
                        />
                      </div>
                      <Form.Text className="text-muted mt-3">
                        We will email/download you the transaction logs for the selected date range in CSV format. This may take
                        a few minutes based on the size of the data.
                      </Form.Text>
                    </Form.Group>

                    <Form.Group className="mb-3">
                      <Form.Label className="fw-bold">Delivery Method</Form.Label>
                      <div className="d-flex gap-3">
                        <Form.Check
                          type="radio"
                          id="export-email"
                          label="Email me the CSV"
                          name="exportMethod"
                          checked={exportMethod === 'email'}
                          onChange={() => setExportMethod('email')}
                        />
                        <Form.Check
                          type="radio"
                          id="export-download"
                          label="Download now"
                          name="exportMethod"
                          checked={exportMethod === 'download'}
                          onChange={() => setExportMethod('download')}
                        />
                      </div>
                    </Form.Group>

                    <Button
                      variant="contained"
                      type="submit"
                      disabled={!exportDateRange[0] || !exportDateRange[1] || isExporting}
                    >
                      {isExporting ? (
                        <>
                          <CircularProgress size={24} color="inherit" style={{ marginRight: 8 }} />
                          Exporting...
                        </>
                      ) : (
                        'Submit'
                      )}
                    </Button>
                  </Form>
                </div>
              </Modal.Body>

              {isExporting && (
                <div
                  style={{
                    position: 'fixed',
                    top: 0,
                    left: 0,
                    width: '100vw',
                    height: '100vh',
                    backgroundColor: 'rgba(0, 0, 0, 0.6)',
                    zIndex: 9999,
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                  }}
                >
                  <div
                    style={{
                      background: 'white',
                      padding: '30px',
                      borderRadius: '8px',
                      textAlign: 'center',
                      maxWidth: '400px',
                      boxShadow: '0 4px 12px rgba(0,0,0,0.2)',
                    }}
                  >
                    <CircularProgress size={48} />
                    <h4 style={{ marginTop: '20px', marginBottom: '10px' }}>
                      Preparing your export...
                    </h4>
                    <p style={{ fontSize: '14px', color: '#555' }}>
                      Please wait, this may take a few minutes.
                      <br />
                      <strong style={{ color: '#d32f2f' }}>
                        Do not refresh or leave this page,
                      </strong>{' '}
                      as this will cancel the download.
                    </p>
                  </div>
                </div>
              )}
            </Modal>
          </>
        </div>
      </div>
    </>
  );
};

export default TgTransaction;
